import React from 'react';

const ApplicationStatusIndicator = ({ status, size = 'default', showLabel = true }) => {
  const statusConfig = {
    pending: {
      label: 'Offen',
      color: 'bg-muted text-muted-foreground',
      dotColor: 'bg-muted-foreground'
    },
    processing: {
      label: 'Beantragt',
      color: 'bg-warning/10 text-warning',
      dotColor: 'bg-warning'
    },
    approved: {
      label: 'Genehmigt',
      color: 'bg-success/10 text-success',
      dotColor: 'bg-success'
    },
    rejected: {
      label: 'Abgelehnt',
      color: 'bg-error/10 text-error',
      dotColor: 'bg-error'
    },
    redeemed: {
      label: 'Eingelöst',
      color: 'bg-primary/10 text-primary',
      dotColor: 'bg-primary'
    }
  };

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    default: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const dotSizeClasses = {
    sm: 'w-1.5 h-1.5',
    default: 'w-2 h-2',
    lg: 'w-2.5 h-2.5'
  };

  const currentStatus = statusConfig?.[status?.toLowerCase()] || statusConfig?.pending;
  const sizeClass = sizeClasses?.[size] || sizeClasses?.default;
  const dotSizeClass = dotSizeClasses?.[size] || dotSizeClasses?.default;

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full font-medium transition-smooth ${currentStatus?.color} ${sizeClass}`}
      role="status"
      aria-label={`Status: ${currentStatus?.label}`}
    >
      <span className={`rounded-full ${currentStatus?.dotColor} ${dotSizeClass}`} aria-hidden="true" />
      {showLabel && <span>{currentStatus?.label}</span>}
    </div>
  );
};

export default ApplicationStatusIndicator;